export function nextMonitorJobsTableKey(tableKey) {
  return tableKey + 1;
}
